import { createBrowserRouter } from "react-router-dom";
import Home from "../components";
import Counter from "../components/counter";
const Router = createBrowserRouter([
  { path: "/", element: <Home /> },
  {
    path: "/counter",
    element: <Counter />,
  },
  {
    path: "/hw",
    element: <div>Hello world!</div>,
  },
]);

export default Router;
